// constant for months array
export const Months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

// constant list of allowed file formats to upload
export const AllowedFileExtensions: string[] = [
  // Document files
  ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".txt", ".rtf", ".odt",

  // Image files
  ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg",

  // Audio files
  ".mp3", ".wav", ".ogg", ".m4a",

  // Video files
  ".mp4", ".mov", ".avi", ".wmv", ".webm",

  // Archive files
  // ".zip", ".rar", ".7z", ".tar", ".gz",

  // data files
  ".csv", ".json", ".xml",
];


export const mimeTypeMap: Map<string, string> = new Map( [
  // Document files
  [".pdf", "application/pdf"],
  [".doc", "application/msword"],
  [".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  [".xls", "application/vnd.ms-excel"],
  [".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  [".ppt", "application/vnd.ms-powerpoint"],
  [".pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  [".txt", "text/plain"],
  [".rtf", "application/rtf"],
  [".odt", "application/vnd.oasis.opendocument.text"],

  // Image files
  [".jpg", "image/jpeg"],
  [".jpeg", "image/jpeg"],
  [".png", "image/png"],
  [".gif", "image/gif"],
  [".bmp", "image/bmp"],
  [".webp", "image/webp"],
  [".svg", "image/svg+xml"],

  // Audio files
  [".mp3", "audio/mpeg"],
  [".wav", "audio/wav"],
  [".ogg", "audio/ogg"],
  [".m4a", "audio/mp4"],

  // Video files
  [".mp4", "video/mp4"],
  [".mov", "video/quicktime"],
  [".avi", "video/x-msvideo"],
  [".wmv", "video/x-ms-wmv"],
  [".webm", "video/webm"],

  // Archive files (commented out in original)
  // [".zip", "application/zip"],
  // [".rar", "application/vnd.rar"],
  // [".7z", "application/x-7z-compressed"],
  // [".tar", "application/x-tar"],
  // [".gz", "application/gzip"],

  // Data files
  [".csv", "text/csv"],
  [".json", "application/json"],
  [".xml", "application/xml"]
] );

export const FormFieldType: Map<string, string> = new Map([
  ["LARGE_TEXT", "largeText"],
  ["EMPTY_LINE", "emptyLineWithLabel"],
  ["EMPTY_SLOT", "emptySlotWithLabel"],
  ["BOLD_TEXT", "boldTextWithLabel"],
  ["EMPTY_LINE", "emptyLine"],
  ["DATE", "date"],
  ["TIME", "time"],
  ["DD", "dropdown"],
  ["MSDD", "dropdown"],
  ["RADIO", "radio"],
  ["PHONE", "phone"],
  ["EMAIL", "email"],
  ["NUMBER", "number"],
  ["TEXT", "text"],
  ["CARE_TEAM_PICKER", "careTeamPicker"],
  ["CLIENT_MED_LIST", "clientMedList"],
  ["CENTRAL_NOTES", "centralNotes"],
  ["ADMIT_VISIT", "adminVisit"],
] );


